export default {
  amount: (number) => {
    let strList = String(number).split('.')
    strList[0] = strList[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    return strList.join('.')
  }
}



// WEBPACK FOOTER //
// ./src/filter/modules/amount.js